import React from "react";
import {
  AbsoluteFill,
  Audio,
  interpolate,
  OffthreadVideo,
  Sequence,
  staticFile,
  useCurrentFrame,
} from "remotion";

export const CemilanBanuaPromo: React.FC = () => {
  const frame = useCurrentFrame();

  // Durasi Total: 1130 frames (18.83 detik @ 60fps - Sinkron VN Zura Asli)
  // 8 DYNAMIC FAST CUTS DENGAN HOOK MAKANAN INSTAN:
  // Cut 1: 0 - 144 (0.0 - 2.4s) -> Macro Basreng Pedas Daun Jeruk (Visual Magnet!)
  // Cut 2: 144 - 276 (2.4 - 4.6s) -> Plang Promosi SERBA 5000 di Lapak
  // Cut 3: 276 - 420 (4.6 - 7.0s) -> Hamparan Meja Penuh Jajanan Tumpah Ruah
  // Cut 4: 420 - 540 (7.0 - 9.0s) -> Suasana Ramai Festival Remaja Menyala
  // Cut 5: 540 - 660 (9.0 - 11.0s) -> Kamera Melangkah Cepat ke Tenda Biru
  // Cut 6: 660 - 804 (11.0 - 13.4s) -> Seberang Jalan / Patokan Kantor DPRD HST
  // Cut 7: 804 - 936 (13.4 - 15.6s) -> Spanduk Megah MACAM-MACAM CEMILAN
  // Cut 8: 936 - 1130 (15.6 - 18.83s) -> Tangan Genggam 3 Bungkus & Closing Serbu!

  // Dynamic Header Badge & Title Config
  let badgeText = "FESTIVAL REMAJA MENYALA";
  let mainTitle = "WARGA BARABAI MERAPAT!";
  let subTitle = "Jajanan Pasar Malam Serba 5 Ribuan";
  let titleColor = "#FFE500";

  if (frame >= 144 && frame < 276) {
    badgeText = "HARGA RECEH KAKI LIMA";
    mainTitle = "SERBA 5 RIBUAN AJA!";
    subTitle = "Ramah di Kantong Semua Kalangan";
    titleColor = "#00E676";
  } else if (frame >= 276 && frame < 420) {
    badgeText = "SURGA CEMILAN BANUA";
    mainTitle = "JAJANANNYA SEBANYAK INI!";
    subTitle = "Dari Pedas Gurih Sampai Kue Jadul";
    titleColor = "#00F0FF";
  } else if (frame >= 420 && frame < 540) {
    badgeText = "FESTIVAL REMAJA MENYALA";
    mainTitle = "PASAR MALAM RAME BANAR!";
    subTitle = "Teman Pas Nonton & Nongkrong";
    titleColor = "#FFE500";
  } else if (frame >= 540 && frame < 660) {
    badgeText = "STAND CEMILAN BANUA";
    mainTitle = "TENDA BIRU MENYALA";
    subTitle = "Paling Terang di Tengah Acara";
    titleColor = "#00F0FF";
  } else if (frame >= 660 && frame < 804) {
    badgeText = "PATOKAN LOKASI PERSIS";
    mainTitle = "SEBERANG KANTOR DPRD HST";
    subTitle = "Gampang Banget Dicari Buhan Pian";
    titleColor = "#00E676";
  } else if (frame >= 804 && frame < 936) {
    badgeText = "MACAM-MACAM CEMILAN";
    mainTitle = "PILIHANNYA BUANYAK!";
    subTitle = "Basreng, Kerupuk Akar, Wadai Sagu";
    titleColor = "#FFE500";
  } else if (frame >= 936) {
    badgeText = "MALAM INI DI FESTIVAL";
    mainTitle = "BURUAN SERBU SEKARANG!";
    subTitle = "Jangan Sampai Kehabisan Lah!";
    titleColor = "#FF334B";
  }

  // Dynamic Subtitle Timings (Tepat Sesuai Kata-Kata Asli Zura @ 60 FPS)
  // "Bujuran nah, masa nemu jajanan pasar malam serba lima ribuan sebanyak ini di Festival Remaja Menyala, posisinya di seberang kantor DPRD HST, jangan sampai buhan pian kehabisan lah!"
  const subtitles = [
    { start: 0, end: 120, text: "Bujuran nah!", highlight: true },
    { start: 120, end: 320, text: "Masa nemu jajanan pasar malam serba lima ribuan...", highlight: true },
    { start: 320, end: 460, text: "Sebanyak ini di Festival Remaja Menyala!", highlight: true },
    { start: 460, end: 680, text: "Posisinya persis di seberang kantor DPRD HST!", highlight: true },
    { start: 680, end: 900, text: "Pilihan cemilannya buanyak banar...", highlight: false },
    { start: 900, end: 1130, text: "Jangan sampai buhan pian kehabisan lah! 🔥", highlight: true },
  ];

  const currentSub = subtitles.find((s) => frame >= s.start && frame < s.end);

  // Animasi Header Pop-in Halus (60fps interpolation)
  const cutProgress = (frame % 120) / 40;
  const headerOpacity = interpolate(cutProgress, [0, 0.25], [1, 1], {
    extrapolateRight: "clamp",
  });
  const headerTranslateY = interpolate(cutProgress, [0, 0.25], [-8, 0], {
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ backgroundColor: "#000000", overflow: "hidden", fontFamily: "'Poppins', sans-serif" }}>
      {/* 0. LOCAL FONT DECLARATION */}
      <style>{`
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 700;
          src: url('${staticFile("fonts/Poppins-Bold.ttf")}') format('truetype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 800;
          src: url('${staticFile("fonts/Poppins-ExtraBold.ttf")}') format('truetype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 900;
          src: url('${staticFile("fonts/Poppins-ExtraBold.ttf")}') format('truetype');
        }
      `}</style>

      {/* 1. LAYER 60 FPS ULTRA SMOOTH OFFTHREAD VIDEO (ZERO STUTTER, ZERO DROPPED FRAMES) */}
      <AbsoluteFill>
        <OffthreadVideo
          src={staticFile("smooth_vn_bg_60fps.mp4")}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          muted
        />
      </AbsoluteFill>

      {/* 2. DYNAMIC HEADER INFO (SAFE ZONE TIKTOK Y: 220px - 360px) */}
      <div
        style={{
          position: "absolute",
          top: 230,
          left: 60,
          right: 60,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          opacity: headerOpacity,
          transform: `translateY(${headerTranslateY}px)`,
          zIndex: 20,
        }}
      >
        {/* Pill Badge Ringan & Bersih */}
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.55)",
            border: `2px solid ${titleColor}`,
            borderRadius: 50,
            padding: "6px 24px",
            color: "#FFFFFF",
            fontSize: 21,
            fontWeight: 800,
            letterSpacing: 2,
            textTransform: "uppercase",
            marginBottom: 8,
            backdropFilter: "blur(8px)",
          }}
        >
          {badgeText}
        </div>

        {/* Main Title - Font Bold Bersih dengan Glow Halus */}
        <h1
          style={{
            fontSize: 48,
            fontWeight: 900,
            color: titleColor,
            margin: "0 0 4px 0",
            textTransform: "uppercase",
            letterSpacing: 1,
            textShadow: "0 3px 12px rgba(0,0,0,0.9), 0 0 20px rgba(0,0,0,0.7)",
            lineHeight: 1.15,
          }}
        >
          {mainTitle}
        </h1>

        {/* Sub Title */}
        <p
          style={{
            fontSize: 24,
            fontWeight: 700,
            color: "#FFFFFF",
            margin: 0,
            textShadow: "0 2px 8px rgba(0,0,0,0.9)",
          }}
        >
          {subTitle}
        </p>
      </div>

      {/* 3. DYNAMIC KINETIC SUBTITLE (SAFE ZONE TIKTOK Y: 1440px - 1520px) */}
      {currentSub && (
        <div
          style={{
            position: "absolute",
            bottom: 390,
            left: 70,
            right: 140, // Beri jarak 140px dari kanan untuk tombol like/share TikTok
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            zIndex: 40,
          }}
        >
          <div
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              border: currentSub.highlight ? "2.5px solid #FFE500" : "1.5px solid rgba(255, 255, 255, 0.4)",
              boxShadow: currentSub.highlight ? "0 0 30px rgba(255, 229, 0, 0.45)" : "0 4px 20px rgba(0,0,0,0.7)",
              borderRadius: 22,
              padding: "14px 30px",
              backdropFilter: "blur(8px)",
              maxWidth: 820,
            }}
          >
            <span
              style={{
                fontSize: 34,
                fontWeight: 900,
                color: currentSub.highlight ? "#FFE500" : "#FFFFFF",
                letterSpacing: 0.5,
                lineHeight: 1.3,
                textShadow: "0 2px 8px rgba(0,0,0,0.9)",
              }}
            >
              {currentSub.text}
            </span>
          </div>
        </div>
      )}

      {/* 4. TRANSITION WHOOSH SOUNDS ON MAJOR CUTS */}
      <Sequence from={144} durationInFrames={60}>
        <Audio src={staticFile("whoosh.mp3")} volume={0.4} />
      </Sequence>
      <Sequence from={420} durationInFrames={60}>
        <Audio src={staticFile("whoosh.mp3")} volume={0.4} />
      </Sequence>
      <Sequence from={660} durationInFrames={60}>
        <Audio src={staticFile("whoosh.mp3")} volume={0.4} />
      </Sequence>
      <Sequence from={936} durationInFrames={60}>
        <Audio src={staticFile("whoosh.mp3")} volume={0.4} />
      </Sequence>

      {/* 5. MAIN AUDIO TRACK: REKAMAN ASLI ZURA TERMODULASI (FOOD VLOGGER CHILL) + BOUNCING TIKTOK BEAT */}
      <Audio src={staticFile("mixed_vn_vlogger_chill.mp3")} volume={1.0} />
    </AbsoluteFill>
  );
};
